import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import AddEditBulkVaultQuestions from "../../components/VaultQuestions/AddEditBulkVaultQuestions";



const AddEditBulkVaultQuestionsPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb  id="title" title2="Vault Questions" link2="/vault-questions" title="Review Bulk Vault Question" />
        <AddEditBulkVaultQuestions/>
      </MasterLayout>
    </>
  );
};

export default AddEditBulkVaultQuestionsPage;
